<template>
  <div v-show="onVisibleSurface">
    <transition name="app-feedback-slide-up">
      <m-card
        v-if="open"
        class="app-feedback-prompt"
        no-padding
      >
        <app-feedback @close="open = false" />
      </m-card>
    </transition>
  </div>
</template>

<script setup>
import AppFeedback from '@/components/AppFeedback.vue';
import useAppFeedback from '@/composables/app-feedback/app-feedback';
import usePrintMode from '@/composables/export/print-mode';
import { MAIN_LAYOUT, SETTINGS_LAYOUT } from '@/lib/layout';
import { computed, onBeforeUnmount, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();
const { isPrint } = usePrintMode();
const { canDisplayAppFeedback } = useAppFeedback();

const askDelayMs = 20 * 1000;

const open = ref(false);
// Evaluated once: the /me cooldown snapshot is not refreshed mid-session.
const askTimer = setTimeout(() => { open.value = canDisplayAppFeedback(); }, askDelayMs);
onBeforeUnmount(() => clearTimeout(askTimer));

// Hidden rather than unmounted off these surfaces, so an answer in progress
// (and its auto-close timer) survives a detour to a plain page or a narrow window.
const onVisibleSurface = computed(() => !isPrint.value
  && !store.state.breakpoint.smAndDown
  && [MAIN_LAYOUT, SETTINGS_LAYOUT].includes(route.meta.layout));
</script>

<style scoped lang="scss" type="text/scss">
  .app-feedback-prompt {
    position: fixed;
    right: 3rem;
    bottom: 3rem;
    width: 38rem;
    z-index: 1;

    &.app-feedback-slide-up-enter-active,
    &.app-feedback-slide-up-leave-active {
      transition: opacity .25s ease, transform .25s ease;
    }

    &.app-feedback-slide-up-enter-from,
    &.app-feedback-slide-up-leave-to {
      opacity: 0;
      transform: translateY(1.2rem);
    }
  }
</style>
